export const set = function (key, value, obj) {
  const clone = Object.assign({}, obj)
  clone[key] = value
  return clone
}
